import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["desktopPanel"]

  connect() {
    this.submenuId = this.element.dataset.submenuId
    this.boundResize = this.#onResize.bind(this)
    window.addEventListener("resize", this.boundResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.boundResize)
    cancelAnimationFrame(this.rafResize)
  }

  open(event) {
    if (event.detail.id !== this.element.dataset.submenuId) return

    const isOpen = !this.element.hasAttribute("is-open")
    this.element.toggleAttribute("is-open", isOpen)

    if (isOpen) this.#positionPanel()
  }

  close () {
    this.dispatch('close', {
      prefix: 'submenu',
      target: window,
      detail: { id: this.submenuId },
    })
    this.element.removeAttribute("is-open")
  }

  closeWithDelay (event) {
    setTimeout(() => { this.close() }, event.currentTarget.dataset.delay || 1000)
  }

  #onResize() {
    if (!this.element.hasAttribute("is-open")) return
    cancelAnimationFrame(this.rafResize)
    this.rafResize = requestAnimationFrame(() => this.#positionPanel())
  }

  #positionPanel() {
    if (!this.hasDesktopPanelTarget) return

    const id = this.element.dataset.submenuId
    const trigger = document.getElementById(`${id}-trigger`)
    if (!trigger) return

    const t = trigger.getBoundingClientRect()
    const panel = this.desktopPanelTarget
    const p = panel.getBoundingClientRect()

    const vw = innerWidth
    const vh = innerHeight
    const gap = 8

    const cx = t.left + t.width / 2 - p.width / 2
    const cy = t.top + t.height / 2 - p.height / 2

    const score = (top, left) => {
      const r = left + p.width
      const b = top + p.height
      return (
        Math.max(0, gap - left) +
        Math.max(0, gap - top) +
        Math.max(0, r - (vw - gap)) +
        Math.max(0, b - (vh - gap))
      )
    }

    let bestTop = cy
    let bestLeft = t.right + gap
    let bestScore = score(bestTop, bestLeft)

    {
      const left = t.left - p.width - gap
      const s = score(cy, left)
      if (s < bestScore) { bestScore = s; bestTop = cy; bestLeft = left }
    }

    {
      const top = t.top - p.height - gap
      const s = score(top, cx)
      if (s < bestScore) { bestScore = s; bestTop = top; bestLeft = cx }
    }

    {
      const top = t.bottom + gap
      const s = score(top, cx)
      if (s < bestScore) { bestScore = s; bestTop = top; bestLeft = cx }
    }

    const top = Math.max(gap, Math.min(bestTop, vh - p.height - gap))
    const left = Math.max(gap, Math.min(bestLeft, vw - p.width - gap))

    panel.style.setProperty("--top", `${top}px`)
    panel.style.setProperty("--left", `${left}px`)
  }
}
